import { IntrospectDefaults } from "./marops-types";

interface MarOpsIntrospection {
  brand: string,
  partner: string,
  partner_plan: string,
  brandDefaults: (url: string) => IntrospectDefaults,
  environment: string,
}

const Introspect: MarOpsIntrospection = {
  brand: '8am',
  partner: '8am',
  partner_plan: '8am_std',
  environment: 'development',
  brandDefaults(url: string): IntrospectDefaults {

    if (url.includes('clientpay')) {
      Introspect.brand = 'ClientPay'
      Introspect.partner = 'clientpay'
      Introspect.partner_plan = 'Clientpay_monthly'
      Introspect.environment = 'production'
    }

    if (url.includes('lawpay')) {
      Introspect.brand = 'LawPay'
      Introspect.partner = 'lawpay',
      Introspect.partner_plan = 'lawpay_monthly'
      Introspect.environment = 'production'
    }

    if (url.includes('mycase')) {
      Introspect.brand = 'MyCase'
      Introspect.partner = 'mycase'
      Introspect.partner_plan = 'mycase_monthly'
      Introspect.environment = 'production'
    }

    if (url.includes('cpacharge')) {
      Introspect.brand = 'CPACharge';
      Introspect.partner = 'cpacharge';
      Introspect.partner_plan = 'cpacharge_monthly';
      Introspect.environment = 'production'
    }

    if (url.includes('8am')) {
      Introspect.brand = '8am';
      Introspect.partner = '8am';
      Introspect.partner_plan = '8am_std';
      if (!url.includes('netlify') && !url.includes(':9005')) {
        Introspect.environment = 'production'
      }
    }

    if (url.includes('woodpecker')) {
      Introspect.brand = 'Woodpecker';
      Introspect.partner = 'woodpecker';
      Introspect.partner_plan = 'woodpecker_monthly';
      Introspect.environment = 'production'
    }

    if (url.includes('casepeer')) {
      Introspect.brand = 'Casepeer';
      Introspect.partner = 'casepeer';
      Introspect.partner_plan = 'casepeer_monthly';
      if (!url.includes('hubspot')) {
        Introspect.environment = 'production';
      }
    }

    if (url.includes('docketwise')) {
      Introspect.brand = 'Docketwise';
      Introspect.partner = 'docketwise';
      Introspect.partner_plan = 'docketwise_monthly';

      if (!url.includes('webflow')) {
        Introspect.environment = 'production'
      }
      
    }

    if (url.includes('soluno')) {
      Introspect.brand = 'Soluno';
      Introspect.partner = 'soluno';
      Introspect.partner_plan = 'soluno_monthly';
    }

    // Set the default session values if they dont already exist
    if (window && window.sessionStorage) {
      window.sessionStorage.getItem('partner') || window.sessionStorage.setItem('partner', Introspect.partner);
      window.sessionStorage.getItem('plan') || window.sessionStorage.setItem('partner_plan', Introspect.partner_plan);
    }

    return { ...Introspect };
  }
};

export default Introspect;
